import { FormikHelpers } from "formik";

import { CompanyServiceType } from "@vahak/core/dist/constants/serviceTypeId";
import { useAuth } from "@vahak/core/dist/components/auth/useAuth";

import { LoginFormFieldsTypes } from "../../login-form-new/common/contant";
import { LoginFormAuthResult } from "../../login-form-new/hooks/loginFormAuth.types";
import { LoginEventTracker, setOtpFieldError, trackNewUserSignupStarted } from "../../login-form-new/hooks/auth";
import { resolveLoginFormPlaceId } from "../../login-form-new/hooks/auth/buildLoginFormInitialValues";

interface AutoRegisterNewUserParams {
    values: LoginFormFieldsTypes;
    helpers: FormikHelpers<LoginFormFieldsTypes>;
    otpStatus: LoginFormAuthResult;
    globalData?: { userPlaceInfo?: { place_id?: string } };
    defaultPlaceId?: string;
    defaultCompanyName?: string;
    defaultServiceType?: CompanyServiceType;
    phoneNum?: string | number;
    onSubmitCompanyDetails: ReturnType<typeof useAuth>["onSubmitCompanyDetails"];
    handleEventTracking: LoginEventTracker;
    completeNewUserRegistration: (values: LoginFormFieldsTypes, result: LoginFormAuthResult) => Promise<void>;
}

/** Registers a new user inline after OTP — used by compact posting/bidding flows (no company-name step). */
export async function autoRegisterNewUser({
    values,
    helpers,
    otpStatus,
    globalData,
    defaultPlaceId,
    defaultCompanyName,
    defaultServiceType,
    phoneNum,
    onSubmitCompanyDetails,
    handleEventTracking,
    completeNewUserRegistration
}: AutoRegisterNewUserParams) {
    const companyName = values.companyName || defaultCompanyName || `User${String(values.phoneNumber).slice(-4)}`;
    const serviceType = values.serviceType || defaultServiceType || "";
    const currentPlaceID = resolveLoginFormPlaceId(globalData, defaultPlaceId);

    const result = await onSubmitCompanyDetails({
        name: companyName,
        userId: otpStatus.userId,
        serviceType,
        placeId: currentPlaceID
    });

    if (!result) {
        setOtpFieldError(helpers, "Unable to complete registration. Please try again.");
        return;
    }

    trackNewUserSignupStarted(handleEventTracking, result as LoginFormAuthResult, phoneNum);

    await completeNewUserRegistration(
        { ...values, companyName, serviceType, currentPlaceID },
        result as LoginFormAuthResult
    );
}
